// CreationRecord component entry file
import CreationRecord from './CreationRecord';

export default CreationRecord;